import { ReactNode } from 'react';
import { ManageAllModal } from '@frontend/manage-all-modal';
import { ModalControlResponse } from '@frontend/design-system';

type Props = {
  children: ReactNode;
  disabledPrimary?: boolean;
  filteredLocationIds: string[];
  handleSave: () => void;
  helperText?: string;
  minWidth?: number;
  modalControls: ModalControlResponse;
  title: string;
};

/**
 * This is a custom modal component for managing Weave Assistant settings across multiple locations.
 *
 * @param filteredLocationIds - array of location IDs the user has filtered by, this determines which accordion items are displayed
 * @param handleSave - Function to handle saving the changes made in the modal
 * @param localAllLocations - location data managed within the modal before the user clicks save
 * @param modalControls - Modal control response containing modal properties and functions
 * @param setLocalAllLocations - Function to set the local locations state
 * @param title - title for the modal
 *
 * @returns MultiLocationAccordionControlModal component
 */
export const MultiLocationAccordionControlModal = ({
  children: ModalBody,
  disabledPrimary,
  filteredLocationIds,
  handleSave,
  helperText,
  modalControls,
  title,
  ...rest
}: Props) => {
  const { closeModal, modalProps } = modalControls;

  return (
    <ManageAllModal
      filteredLocationIds={filteredLocationIds}
      modalProps={{ ...modalProps, onClose: closeModal }}
      title={title}
      {...rest}
    >
      {ModalBody}
      <ManageAllModal.Footer
        disabledPrimary={disabledPrimary}
        helperText={helperText}
        onCancel={closeModal}
        onSave={handleSave}
      />
    </ManageAllModal>
  );
};
